//页面调用推荐对应传参
export enum SceneCode {
  HOME_PAGE = 'home_page', //首页
  PRODUCT_DETAIL_PAGE = 'product_detail_page', //商详页
  CART_PAGE = 'cart_page', //购物车
  PAY_SUCCESS_PAGE = 'pay_success_page', //支付成功
  USER_CENTER_PAGE = 'user_center_page', //个人中心
  ORDER_LIST = 'order_list', //订单列表
  ORDER_DETAIL = 'order_detail', //订单详情
  REVIEW_PAGE = 'review_page', //评价
  WISH_LIST = 'wish_list', //心愿单
  MESSAGE_BOX = 'message_box', //消息
  AFTER_SALES = 'after_sales', //售后
  REVIEW_LIST = 'review_list', //评价列表
  FREE_SHIPPING_PAGE = 'free_shipping_page', //凑单页
  HOME_CHANNEL_PAGE = 'home_channel_page', //小首页
  FEWER_RESULTS = 'fewer_results', //搜索无少结果
}

//获取推荐tab列表入参
export interface SlotListReq {
  sceneCode: SceneCode;
}
//小首页推荐需要的传参
export interface ChannelPageType {
  channelPageName?: string;
  poolIdList: number[];
}
//湖区推荐数据
export interface RecommendDataReq {
  sceneCode?: SceneCode;
  subSceneCode?: string;
  page?: number;
  pageSize?: number;
  bulkPrice?: string;
  mainSkus?: string;
  c3Id?: string;
  channelPage?: ChannelPageType;
}

//推荐tab列表数据格式
export interface ISlotItem {
  slotId: string;
  slotName: string;
}
